import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionPlanCheckInAndCheckOut } from "./check-in-and-check-out";
import { QuestionPlanCheckInAvailableDayOfTheWeek } from "./check-in-available-day-of-the-week";
import { QuestionPlanRequiredPrepMillisecond } from "./required-prep-milli-second";
import { QuestionPlanSaleStartBeforeDate } from "./sale-start-before-date";
import { QuestionPlanSaleTerm } from "./sale-term";
import { QuestionPlanStayableDayOfTheWeek } from "./stayable-day-of-the-week";
import { useStandardPlanScConnected } from "../price-and-policy/sc-connected";

import type { PlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	term: PlanCategoriesAndManagerStore["term"];
};

export const QuestionPlanTerm = ({ term }: Props) => {
	const { isSCConnected } = useStandardPlanScConnected();

	return (
		<>
			<FeatureIslandMainWithCategoryWrapper islandTitle="期間の制限" categoryStore={term}>
				<div className="space-y-4">
					{isSCConnected?.value && (
						<p className="text-error-600">
							サイトコントローラー連携中でも販売期間を設定できます。
							<br />
							ただし、この期間はサイトコントローラー側には反映されず、CHILLNN上でのみ有効です。
						</p>
					)}
					<QuestionPlanSaleTerm />
				</div>
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="曜日の制限" categoryStore={term}>
				<div className="space-y-4">
					{isSCConnected?.value && (
						<p className="text-error-600">
							サイトコントローラー連携中でも曜日の制限を設定できます。
							<br />
							ただし、この制限はサイトコントローラー側には反映されず、CHILLNN上でのみ有効です。
						</p>
					)}
					<QuestionPlanStayableDayOfTheWeek />
					<QuestionPlanCheckInAvailableDayOfTheWeek />
				</div>
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="チェックイン・チェックアウト" categoryStore={term}>
				<QuestionPlanCheckInAndCheckOut />
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper islandTitle="時間の制限" categoryStore={term}>
				<QuestionPlanSaleStartBeforeDate />
				<QuestionPlanRequiredPrepMillisecond />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionPlanTerm.displayName = "QuestionPlanTerm";
